"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const env_1 = require("../../env");
const api_1 = __importDefault(require("./api"));
const api_mock_1 = __importDefault(require("./api.mock"));
const api = {
    fetchHistorical: (granularity, pair) => (0, env_1.getEnv)("MOCK_COUNTERVALUES")
        ? api_mock_1.default.fetchHistorical(granularity, pair)
        : api_1.default.fetchHistorical(granularity, pair),
    fetchLatest: pairs => (0, env_1.getEnv)("MOCK_COUNTERVALUES") ? api_mock_1.default.fetchLatest(pairs) : api_1.default.fetchLatest(pairs),
    fetchMarketcapTickers: () => (0, env_1.getEnv)("MOCK_COUNTERVALUES")
        ? api_mock_1.default.fetchMarketcapTickers()
        : api_1.default.fetchMarketcapTickers(),
};
exports.default = api;
//# sourceMappingURL=index.js.map